import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { LayerInfo } from '@root/search/models/map.models';
import { select, Store } from '@ngrx/store';
import { AppState } from '@root/app-state.module';
import {
  SetPropertyCharacteristic,
  ToggleDistressedProperty,
  ToggleLocationInformation,
  ToggleMlsListing,
  ToggleSalesValue
} from '@store/search-board/search-board.actions';
import { Observable } from 'rxjs';
import {
  selectDistressedPropertiesLayers,
  selectLayersLimitReached,
  selectLocationInformationLayers,
  selectMlsListingsLayers,
  selectPropertyCharacteristic,
  selectPropertyCharacteristicsLayers,
  selectSalesValuesLayers
} from '@store/map-layers.selector';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'rlst-property-sales',
  templateUrl: './property-sales.component.html',
  styleUrls: ['./property-sales.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PropertySalesComponent implements OnInit {
  @Input() index: number;

  public layersLimitReached: boolean = false;

  public propertyCharacteristics$: Observable<Array<LayerInfo>>;
  public distressedProperties$: Observable<Array<LayerInfo>>;
  public salesValues$: Observable<Array<LayerInfo>>;
  public mlsListings$: Observable<Array<LayerInfo>>;
  public locationInformation$: Observable<Array<LayerInfo>>;
  public selectedPropertyCharacteristic$: Observable<LayerInfo>;

  constructor(
    private readonly store$: Store<AppState>) {
  }

  public ngOnInit(): void {
    this.distressedProperties$ = this.store$.pipe(
      select(selectDistressedPropertiesLayers)
    );

    this.salesValues$ = this.store$.pipe(
      select(selectSalesValuesLayers)
    );

    this.mlsListings$ = this.store$.pipe(
      select(selectMlsListingsLayers)
    );

    this.locationInformation$ = this.store$.pipe(
      select(selectLocationInformationLayers)
    );

    this.propertyCharacteristics$ = this.store$.pipe(
      select(selectPropertyCharacteristicsLayers)
    );

    this.selectedPropertyCharacteristic$ = this.store$.pipe(
      select(selectPropertyCharacteristic)
    );

    this.store$.pipe(
      select(selectLayersLimitReached),
      untilDestroyed(this)
    )
      .subscribe((limitReached: boolean) => this.layersLimitReached = limitReached);
  }

  public toggleDistressedProperty(layer: LayerInfo): void {
    this.store$.dispatch(new ToggleDistressedProperty(layer));
  }

  public toggleLocationInformation(layer: LayerInfo): void {
    this.store$.dispatch(new ToggleLocationInformation(layer));
  }

  public toggleMlsListing(layer: LayerInfo): void {
    this.store$.dispatch(new ToggleMlsListing(layer));
  }

  public toggleSalesValue(layer: LayerInfo): void {
    this.store$.dispatch(new ToggleSalesValue(layer));
  }

  public setPropertyCharacteristic(layer: LayerInfo): void {
    this.store$.dispatch(new SetPropertyCharacteristic(layer));
  }

  public trackByLayerId(_: number, layer: LayerInfo): string {
    return layer.layerId;
  }

  public isLayerDisabled(layer: LayerInfo): boolean {
    return this.layersLimitReached && !layer.isSelected;
  }
}
